
const ms01 = {
  label: "Title",
  pageLabel: "Title",
  starting: true,
  url: "ms01",
  pageType: "history",
  form: [
    {
      inputType: "handsonTable",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "title",
      description: "none",
      tableOptions: {
        // validations, basic calculations, colors, date pickers, context menu etc.
        HOTheaders: ["Code", "Description.", "Active", "Descn(Regional)"],
        columns: [{}, {}, {}, {}],
        rowHeaders: false,
        // contextMenu: true,
        minSpareRows: 4,
        stretchH: "last",
        // columnSorting: true,
        autoWrapRow: true,
        maxRows: 100
      }
    }
  ]
};
export default ms01;
